// Module
var code = " <md-card> <h2 translate=\"PRESENTER_ERROR_HEADING\" class=\"md-headline\"></h2> <p translate=\"PRESENTER_ERROR_DESCRIPTION\" class=\"md-body-1\"></p> </md-card> ";
// Exports
export default code;